import { LinearProgress, Typography, Grid } from "@material-ui/core";
import * as React from "react";
import { FC } from "react";
import { useGetMeQuery } from "../../api/rtk/MeApi";
import UserReadOnlyView from "../home/UserReadOnlyView";
import TranslatedMessage from "../translations/TranslatedMessage";

const MyUser: FC = () => {
  const { data: me, isFetching: isMeFetching } = useGetMeQuery();

  if (isMeFetching) {
    return (
      <Grid item xs={12}>
        <LinearProgress variant="query" />
      </Grid>
    );
  }

  if (me === undefined) {
    return (
      <Typography>
        <TranslatedMessage id="user.noInfo" />
      </Typography>
    );
  }

  return <UserReadOnlyView user={me} />;
};

export default MyUser;
